import { withRouter } from 'react-router-dom';
import ShopSection from './ShopSection';
import ShopSectionContainer from './ShopSection.container';

export default withRouter(ShopSectionContainer(ShopSection));
